
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find/[mode]",
      function () {
        return require("private-next-pages/find/[mode].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find/[mode]"])
      });
    }
  